import cx from 'classnames';

import { Box, Button, Divider, Heading } from '@flixbus/honeycomb-react';

import { crewMemberInfoText } from '../text';

import styles from './styles.module.css';

const Availability = ({ employeeInfo, onOpenAbsence }) => {
	if (!employeeInfo) return null;

	const { lastAssignmentLabel, nextAvailableLabel } = employeeInfo;

	return (
		<Box extraClasses={cx(styles.block, styles.availabilityBlock)}>
			<div className={styles.blockItem}>
				<div className={styles.fullwidth}>
					<Heading size={3} sectionHeader>
						{crewMemberInfoText.lastAssignment}
					</Heading>
					<div className={styles.arrivedLocation}>{lastAssignmentLabel}</div>
				</div>
			</div>

			<Divider />

			<div className={styles.blockItem}>
				<Heading size={3} sectionHeader>
					{crewMemberInfoText.nextAvailability}
				</Heading>
				<div className={styles.blockRow}>
					{nextAvailableLabel}
					<Button extraClasses={styles.btn} onClick={onOpenAbsence}>
						{crewMemberInfoText.scheduleAbsence}
					</Button>
				</div>
			</div>
		</Box>
	);
};

export default Availability;
